import { Nav } from '@betterment/samba-react';

import { NavLink } from '../nav-link/NavLink';

export const SettingsNav = () => (
  <>
    <Nav.Separator />
    <Nav aria-label="Settings">
      <Nav.List>
        <Nav.ListItem key="settings">
          <NavLink to="/settings">
            <NavLink.Icon name="Gear" />
            <NavLink.Text>Settings</NavLink.Text>
          </NavLink>
        </Nav.ListItem>
        <Nav.ListItem key="log out">
          <NavLink to="/login?logout=true" rel="nofollow" data-method="delete" reloadDocument={true}>
            <NavLink.Icon name="Power" />
            <NavLink.Text>Log out</NavLink.Text>
          </NavLink>
        </Nav.ListItem>
      </Nav.List>
    </Nav>
  </>
);
